/**
 * @prettier
 */
import { pidedirectoApiMethod } from 'src/api/pidedirectoApiMethod';
import type { ApiSauceResponse } from 'src/api/types/ApiSauceResponse';

export async function hasUserSignedUpApi(): ApiSauceResponse<boolean> {
    return pidedirectoApiMethod('customer/hasUserSignedUpApi', undefined);
}
